import {AppActions, AppActionType} from './app.types';
import {AppState, Instructions} from "../../util/interfaces";

const initialUserInfo = {
  givenName: '',
  familyName: '',
  email: ''
}

const initialState: AppState = {
  isDev: process.env.NODE_ENV === 'development',
  initComplete: false,
  userInfo: initialUserInfo,
  signupType: null,
  instructions: {},
  queryParams: {},
  extendedRegistrationParams: {},
  urlExtension: '',
  isInvoiceClaimed: false,
  claimedInvoiceError: '',
  isLoading: false,
  isBusinessLogin: false,
  industries: [],
  countries: []
}

export const appReducer = (state: AppState = initialState, action: AppActionType): AppState => {
  switch(action.type){

    case AppActions.INIT_COMPLETE:
      return {...state, initComplete: true};
    case AppActions.SET_USER_INFO:
      return {...state, userInfo: {...action.payload}};
    case AppActions.CLEAR_USER_INFO:
      return {...state, userInfo: initialUserInfo};
    case AppActions.SET_SIGNUP_TYPE:
      return {...state, signupType: action.payload};
    case AppActions.PARSE_PARAMS:
      const instructions: Instructions = {};
      const queryParams: { [key: string]: string} = {};
      let urlExtension = ''
      const splitUrl:string[] = action.payload.split('?');
      if(splitUrl.length > 1){
        urlExtension = '?' + splitUrl[1];
        splitUrl[1].split('&').forEach((p) => {
          const temp: string[] = p.split('=');
          queryParams[temp[0]] = temp[1];
          if (temp[0] === 'context'){
            let context;
            try {
              context = JSON.parse(atob(temp[1]));
            } catch (err) {
              context = null;
              console.log('Error parsing context: Not a valid JSON object');
            }
            instructions.context = context;
          } else if (temp[0] === 'apply' && temp[1]) {
            instructions.apply = temp[1]
          }
        })
      }
      return {...state, instructions, urlExtension, queryParams};
    case AppActions.REMOVE_PARAMS:
      const updatedQueryParams: { [key: string]: string} = {};
      let updatedUrlExtension = '';
      for(let key in state.queryParams) {
        if(!action.payload.includes(key)) {
          updatedQueryParams[key] = state.queryParams[key];
        }
      }
      const keysArray = Object.keys(updatedQueryParams);
      if(keysArray.length) {
        updatedUrlExtension += '?';
        Object.keys(updatedQueryParams).forEach((key, index) => {
          updatedUrlExtension += `${key}=${updatedQueryParams[key]}`;
          if(index + 1 < keysArray.length) {
            updatedUrlExtension += '&';
          }
        })
      }
      return {...state, urlExtension: updatedUrlExtension, queryParams: updatedQueryParams};
    case AppActions.SUCCESS_CLAIM_INVOICE:
      return {...state, isInvoiceClaimed: true};
    case AppActions.FAILED_CLAIM_INVOICE:
      return {...state, claimedInvoiceError: action.payload};
    case AppActions.SET_IS_LOADING:
      return {...state, isLoading: action.payload};
    case AppActions.SET_EXTENDED_REGISTRATION_PARAMS:
      return {...state, extendedRegistrationParams: action.payload};
    case AppActions.SET_IS_BUSINESS_LOGIN:
      return {...state, isBusinessLogin: action.payload};
    case AppActions.SET_INDUSTRIES:
      return {...state, industries: action.payload};
    case AppActions.SET_COUNTRIES:
      return {...state, countries: action.payload};
    default:
      return state
  }
}
